import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Avatar, Chip, IconButton, Tooltip } from '@mui/material';
import { MenuBook as MenuBookIcon, Visibility as VisibilityIcon } from '@mui/icons-material';
import { getAllReadings, deleteReading } from '../../api/readingApi';
import { GenericListPage } from '../../components/templates';

const ReadingList = () => {
  const navigate = useNavigate();

  const columns = [
    {
      field: 'label',
      headerName: 'Reading Title',
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar
            sx={{
              backgroundColor: params.row.isPractice ? 'info.main' : 'success.main',
              width: 32,
              height: 32,
              fontSize: '0.875rem',
            }}
          >
            {params.row.isPractice ? 'P' : 'R'}
          </Avatar>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'type',
      headerName: 'Type',
      flex: 0.8,
      renderCell: (params) => (
        <Chip
          label={params.row.isPractice ? 'Practice' : 'Real Exam'}
          color={params.row.isPractice ? 'info' : 'success'}
          size="small"
          variant="outlined"
          sx={{ fontWeight: 500 }}
        />
      ),
    },
  ];

  const extraActions = (row) => (
    <Tooltip title="Question Sets">
      <IconButton
        onClick={() => navigate(`/readings/${row._id}/question-sets`)}
        size="small"
        sx={{ color: 'info.main', '&:hover': { backgroundColor: 'info.50' } }}
      >
        <VisibilityIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );

  return (
    <GenericListPage
      title="Reading Management"
      subtitle="Create and manage reading passages and question sets"
      icon={<MenuBookIcon />}
      entityName="Reading"
      columns={columns}
      fetchData={getAllReadings}
      deleteItem={deleteReading}
      createPath="/readings/new"
      editPath="/readings"
      extraActions={extraActions}
      tabs={[
        { label: 'Practice Tests', color: 'info' },
        { label: 'Real Exams', color: 'success' },
      ]}
      filterKey="isPractice"
      filterValues={[true, false]}
    />
  );
};

export default ReadingList;
